<template>
  <div>
    <div class="search-form">
      <el-input v-model="config.deliveryName"
                style="width: 300px"
                placeholder="请输入收货方名称"
                clearable="">
        <el-button slot="append"
                   icon="el-icon-search"
                   @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table v-loading="loading"
              border
              height="442px"
              :data="list"
              @row-click="handleRowClick">
      <el-table-column label="收货方名称"
                       min-width="140"
                       prop="deliveryName"></el-table-column>
      <el-table-column label="联系电话"
                       min-width="120"
                       prop="deliveryPhone"></el-table-column>
      <el-table-column label="收货地址"
                       width="240">
        <template slot-scope="{row}">{{ row.provinceName}}-{{row.cityName}}-{{row.areaName}}-{{row.detailedAddress}}</template>
      </el-table-column>
    </el-table>
    <el-pagination background
                   style="text-align: center;"
                   :current-page="config.pageNum"
                   :page-size="config.pageSize"
                   layout="total, prev, pager, next"
                   :total="total"
                   @current-change="handleCurrentChange"></el-pagination>
  </div>
</template>
<script>
export default {
  name: 'PackageSelectList',
  props: {
    options: { type: Object, default () { return {} } }
  },
  data () {
    return {
      loading: false,
      list: [],
      config: { pageNum: 1, pageSize: 10, deliveryName: '' },
      total: 0
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    handleCurrentChange (cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    handleRowClick (row) {
      const { deliveryAddressId, deliveryName, provinceName, cityName, areaName, detailedAddress } = row
      this.$emit('select', { deliveryAddressId, deliveryName, address: provinceName + cityName + areaName + '-' + detailedAddress })
    },
    fetchList () {
      this.loading = true
      this.$store.dispatch('delivery/getdeliveryaddresses', {
        payload: { ...this.config, ...this.options },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
